function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.25 7.48633L27.42 7.48633M5 7.48633L20.87 7.48633M11.99 16.1563L27.42 16.1563M6.17 16.1563L5 16.1563M18.17 24.8363L27.42 24.8363M5 24.8363L11.99 24.8363M25.77 7.48633C25.77 8.72897 24.7626 9.73633 23.52 9.73633C22.2774 9.73633 21.27 8.72897 21.27 7.48633C21.27 6.24369 22.2774 5.23633 23.52 5.23633C24.7626 5.23633 25.77 6.24369 25.77 7.48633ZM11.15 16.1563C11.15 17.399 10.1426 18.4063 8.9 18.4063C7.65736 18.4063 6.65 17.399 6.65 16.1563C6.65 14.9137 7.65736 13.9063 8.9 13.9063C10.1426 13.9063 11.15 14.9137 11.15 16.1563ZM17.24 24.8363C17.24 26.079 16.2326 27.0863 14.99 27.0863C13.7474 27.0863 12.74 26.079 12.74 24.8363C12.74 23.5937 13.7474 22.5863 14.99 22.5863C16.2326 22.5863 17.24 23.5937 17.24 24.8363Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSliders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.17ec1b2a.svg";
export { ForwardRef as ReactComponent };